module.exports = __webpack_public_path__ + "static/media/aldair_persona.74945b94.png";